import CityPageTemplate from "../city-template/CityPageTemplate";
import { hampdenConfig } from "./data";

export default function HampdenPage() {
  return <CityPageTemplate config={hampdenConfig} />;
}